/**
 * OS já no formato do Board (API mapeou no backend): evita clonar no front.
 */
export function isBoardReadyOrder(ordem) {
  if (!ordem || typeof ordem !== 'object') return false;
  const id = ordem.id;
  if (id == null || String(id).trim() === '') return false;
  return Object.prototype.hasOwnProperty.call(ordem, 'cliente');
}

export function reuseBoardOrderOrMap(ordem, mapOrder) {
  if (isBoardReadyOrder(ordem)) return ordem;
  return mapOrder(ordem);
}

export function reuseBoardOrders(ordens, mapOrder) {
  if (!Array.isArray(ordens) || ordens.length === 0) return ordens || [];
  for (let i = 0; i < ordens.length; i++) {
    if (!isBoardReadyOrder(ordens[i])) {
      return ordens.map((ordem) => reuseBoardOrderOrMap(ordem, mapOrder));
    }
  }
  return ordens;
}
